import { useEffect, useState } from 'react';

function matches(query: string): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(query).matches
    : false;
}

/** Реактивный CSS media query: перерисовывает компонент при пересечении брейкпоинта. */
export function useMediaQuery(query: string): boolean {
  const [state, setState] = useState(() => matches(query));
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(query);
    const onChange = () => setState(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);
  return state;
}

/**
 * Узкий экран (< 640px, Tailwind `sm`) — телефон. Для того, что нельзя
 * выразить классами Tailwind: опции ECharts (поля, легенда, тултип).
 */
export function useIsNarrow(): boolean {
  return useMediaQuery('(max-width: 639.98px)');
}
